import React,{ Component } from 'react';
import {Row, Col, Button, ControlLabel, Checkbox} from 'react-bootstrap';
import FieldGroup from '../../../../components/FieldGroup';
import SelectWrap from "../../../../components/SelectWrap";
import countriesObj from "../../../../data/countries";
import { handleFieldChange } from "../../../../Utils";

class Filters extends Component {
    constructor(props) {
        super(props);

        this.state = {
            day: '',
            hourFrom: '',
            hourTo: '',
            compareDay: '',
            compareHourFrom: '',
            compareHourTo: '',
            country: '',
            source: '',
            groupBy: {},
            realtime: false,
        };

        this.handleFieldChange = handleFieldChange.bind(this);
        this.handleGroupByChange = this.handleGroupByChange.bind(this);
        this.handleFormSubmit = this.handleFormSubmit.bind(this);
    }

    handleFormSubmit(e) {
        e.preventDefault();

        const filters = {...this.state};

        filters.groupBy = Object.keys(filters.groupBy);

        if (filters.compareDay) filters.compare = 1;

        this.props.onSubmit(filters, { realtime: this.state.realtime });
    }

    handleGroupByChange({ target }) {
        const groupBy = { ...this.state.groupBy };
        const { name, checked } = target;

        if(checked) groupBy[name] = 1;
        else delete groupBy[name];

        this.setState({ groupBy });
    }

    render() {
        return (
            <form onSubmit={this.handleFormSubmit}>
                <Row>
                    <Col lg={12}>
                        <ControlLabel>Group By:</ControlLabel>

                        <Checkbox onChange={this.handleGroupByChange} name="hour">Hour</Checkbox>
                        <Checkbox onChange={this.handleGroupByChange} name="source">Source</Checkbox>
                        <Checkbox onChange={this.handleGroupByChange} name="onw">ONW</Checkbox>
                        <Checkbox onChange={this.handleGroupByChange} name="country">Country</Checkbox>

                        <Checkbox onChange={(event) => this.setState({ realtime: event.target.checked })} name="realtime">Realtime</Checkbox>
                    </Col>
                    <Col lg={2}>
                        <FieldGroup
                            type="date"
                            name="day"
                            label="Day:"
                            onChange={this.handleFieldChange}
                            value={this.state.day}
                            required
                        />
                    </Col>
                    <Col lg={2}>
                        <FieldGroup
                            type="number"
                            name="hourFrom"
                            label="Hour From:"
                            min={0}
                            max={23}
                            onChange={this.handleFieldChange}
                            value={this.state.hourFrom}
                        />
                    </Col>
                    <Col lg={2}>
                        <FieldGroup
                            type="number"
                            name="hourTo"
                            label="Hour To:"
                            min={0}
                            max={23}
                            onChange={this.handleFieldChange}
                            value={this.state.hourTo}
                        />
                    </Col>
                    <Col lg={2}>
                        <FieldGroup
                            type="date"
                            name="compareDay"
                            label="Compare Day:"
                            onChange={this.handleFieldChange}
                            value={this.state.compareDay}
                        />
                    </Col>
                    <Col lg={2}>
                        <FieldGroup
                            type="number"
                            name="compareHourFrom"
                            label="Compare Hour From:"
                            min={0}
                            max={23}
                            onChange={this.handleFieldChange}
                            value={this.state.compareHourFrom}
                        />
                    </Col>
                    <Col lg={2}>
                        <FieldGroup
                            type="number"
                            name="compareHourTo"
                            label="Compare Hour To:"
                            min={0}
                            max={23}
                            onChange={this.handleFieldChange}
                            value={this.state.compareHourTo}
                        />
                    </Col>
                    <Col lg={6}>
                        <SelectWrap
                            values={countriesObj}
                            label="Countries:"
                            name="country"
                            onChange={this.handleFieldChange}
                            value={this.state.country}
                            multi
                        />
                    </Col>
                    <Col lg={6}>
                        <SelectWrap
                            values={this.props.sources}
                            label="Sources:"
                            name="source"
                            onChange={this.handleFieldChange}
                            value={this.state.source}
                            multi
                        />
                    </Col>
                </Row>

                <Button type="submit" bsStyle="info" className="m-b-15" >Apply</Button>
            </form>
        );
    }
}

export default Filters;



// WEBPACK FOOTER //
// ./src/scenes/BidderHourlyV2/components/Form/index.js